import React, { Component } from 'react'
import { withRouter} from 'react-router-dom'
import { connect } from 'react-redux'

import TopNav from '../../components/navigation/TopNav'


const whatsNewContentLastUpdated=new Date('2019-03-17T22:07:50+0000')
const whatsNewNotificationTimeout= 7 * 24 * 60 * 60 * 1000 //7 days



const navBarIsVisible = (location) => { 
	if(
		!(location.pathname.indexOf('/seteditor/')>-1)  && 
		!(location.pathname.indexOf('/editor/')>-1)  && 
		!(location.pathname.indexOf('/classRoster/')>-1) &&
		!(location.pathname.indexOf('/integration/')>-1) &&
		!(location.pathname.indexOf('/scoresheet')>-1) &&
		!(location.pathname.indexOf('/dnd')>-1) &&
		!(location.pathname.indexOf('/scan-helper')>-1) &&
		!(location.pathname.indexOf('/import-questions-helper')>-1)  

	)return true
	else return false

}


class TopNavContainer extends Component {

	// shouldComponentUpdate(nextProps) {
 //  	if((navBarIsVisible(nextProps.location) !== navBarIsVisible(this.props.location))
 //    		|| (nextProps.user !==this.props.user)|| (nextProps.whatsNewLastSeen !==this.props.whatsNewLastSeen)
 //    		){
 //    		return true
 //    	}else return false
  	
 //  	}

  	shouldDisplayWhatsNewNotification(meta){
  		if(meta && meta.onboardingStatus && meta.onboardingStatus.assignedResponseScanned){ //dont show notification if also showing onboarding wizard
  			if(meta.whatsNewLastSeen){
  				const lastSeenDate= new Date(meta.whatsNewLastSeen)
  				const nowDate = new Date()
  				if((lastSeenDate-whatsNewContentLastUpdated)<0 && (nowDate -whatsNewContentLastUpdated)< whatsNewNotificationTimeout ){
  					return true
  				}else return false
  			}else return true
  		}else return false
  	}



	render() {
		const showNotification = this.shouldDisplayWhatsNewNotification(this.props.meta)

		if(navBarIsVisible(this.props.location)){
			return (        
				<TopNav
					user={this.props.user}
					navigateToAccount={()=>{this.props.history.push('/account')}}
					showWhatsNewNotification={showNotification}
				/> 
			)
		}else return null
	}
}



function mapStateToProps(state,ownProps) {
	const meta = state.meta
	let whatsNewLastSeen = null
	if(meta){
		whatsNewLastSeen=meta.whatsNewLastSeen
	} 

	return {
		user:state.user,
		whatsNewLastSeen:whatsNewLastSeen,
		meta:state.meta


	}
}



export default withRouter(connect(
	mapStateToProps,
	{ }
)(TopNavContainer))



// WEBPACK FOOTER //
// ./src/containers/navigation/TopNavContainer.js